export type PanelResizeAxis = 'x' | 'y';

/** Also sets drag direction: a right/down drag grows a `previous` panel and shrinks a `next` one. */
export type PanelResizeTarget = 'previous' | 'next';

export interface PanelSizeConstraints {
	min: number;
	minAdjacent: number;
}

export interface PanelDragFrame {
	targetSize: number;
	adjacentSize: number;
}

/** The neighbor's floor is the cap, so there is deliberately no maximum-size option. */
export function clampPanelSize(desired: number, frame: PanelDragFrame, constraints: PanelSizeConstraints): number {
	const max = frame.targetSize + frame.adjacentSize - constraints.minAdjacent;
	if (max <= constraints.min) {
		return constraints.min;
	}
	return Math.min(Math.max(desired, constraints.min), max);
}

export function panelSizeFromDrag(
	pointerDelta: number,
	target: PanelResizeTarget,
	frame: PanelDragFrame,
	constraints: PanelSizeConstraints
): number {
	const direction = target === 'previous' ? 1 : -1;
	return clampPanelSize(frame.targetSize + pointerDelta * direction, frame, constraints);
}
